import { css, Global } from '@emotion/core';
import React from 'react';

/**
 * HACK: Overrides Meridian's internal overflow styles to enable position: sticky on table headers
 * within the page scroll context. This targets Meridian's generated CSS class names (css-zcc6r6,
 * css-ufeqog) which set overflow: hidden/auto and break sticky positioning.
 *
 * Meridian's stickyHeaderRow and fixHeaderRows props don't work here because they require the table
 * to be inside a scrollable container, our tables scroll with the page instead.
 *
 * This is fragile and WILL break if Meridian changes its internal class names on upgrade.
 * When upgrading Meridian, check if stickyHeaderRow works natively with page scroll and remove
 * this file if so. See:
 * 5.x: https://meridian.a2z.com/20200624.x/components/table/
 * latest: https://meridian.a2z.com/components/table
 * TODO: Remove this once Meridian supports sticky headers with page-level scroll containers.
 * SIM: https://sim.amazon.com/issues/Bender-7961
 */
export const StickyHeaderStyles = () => (
    <Global
        styles={css`
            [data-testid='purchaseOrderViewPage'] .css-zcc6r6,
            [data-testid='purchaseOrderViewPage'] .css-ufeqog {
                overflow: visible !important;
            }

            [data-testid='poViewAsinTable'] > thead > tr,
            [data-testid='poViewShipmentTable'] > thead > tr {
                position: sticky;
                top: 0;
                z-index: 2;
                background: white;
            }
        `}
    />
);
